import { useEffect, useState } from 'react';
import Tabela from '../../Misc/Tabela/Tabela';
import { Button, Form, Modal } from 'react-bootstrap';
import { usePAChecklistFollowUp } from './pa_checklist_followup_context';
import styles from './pa_checklist_followup.module.scss'
import PAChecklistFollowUpModal from './components/pa_checklist_followup_modal';
import FiltroChecklistFup from './components/pa_checklist_fup_filters';
import PrioritySelector from './components/priorizacao/pa_checklist_prio_comp';
import PrioritySelectorAll from './components/priorizacao/pa_checklist_prio_all';
import { toBrDateWithTime } from '../../../utils/dateUtils';
import ReanaliseHistoricoModal from './components/tinyComps/reanalise_historico_modal';
import ResumoFup from './components/tinyComps/resumo_fup';
import { exportToXlsx } from './components/tinyComps/export_to_xlsx';
import ModalDispensaFup from './components/tinyComps/dispensa_fup';
import { api } from '../../../services/api';
import { toast } from 'react-toastify';
import { useMisc } from '../../../contexts/MiscContext';

const PAChecklistFollowUp = () => {
  const { mainGridData, mainGridDataPrio, getFupData, modalFup, processarChecklistPriorizacao, showModalHistoricoReanalise, showResumo, setShowResumo, usuarioAdminFup, isAdmin, showDispensa, setShowDispensa } = usePAChecklistFollowUp();
  const { setShowLoading } = useMisc();
  const [modoPriorizacao, setModoPriorizacao] = useState(false);
  const [arrPrioridade, setArrPrioridade] = useState([]);
  const [semAlteracoes, setSemAlteracoes] = useState(false);
  const [reseter, setReseter] = useState(false);
  const [modalConfirmacaoTipo, setModalConfirmacaoTipo] = useState(false);
  const [tipoSelecionado, setTipoSelecionado] = useState(null);

  useEffect(() => {
    const arr = [];
    for (const prod of mainGridDataPrio) {
      arr.push({
        prioridade: prod.prioridade,
        nova_prioridade: prod.prioridade,
        nf_segunda_qualidade: prod.nf_segunda_qualidade,
        nova_nf_segunda_qualidade: prod.nova_nf_segunda_qualidade,
        id_entrada_fiscal: prod.id_entrada_fiscal
      });
    }
    setArrPrioridade([...arr]);
  }, [mainGridDataPrio, reseter]);

  useEffect(() => {
    setSemAlteracoes(!arrPrioridade.some(item => (
      item.nova_prioridade !== item.prioridade || item.nova_nf_segunda_qualidade !== item.nf_segunda_qualidade
    )));
  }, [arrPrioridade]);

  const priorities = {
    0: { color: '#D0D0D0' },
    1: { color: '#FFCC00' },
    2: { color: '#FF9500' },
    3: { color: '#F2645E' }
  }

  const priorityCol = (prioridade, grey = false) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '32px',
          fontWeight: 500,
          height: '38px',
          // padding: '10px 6px',
          border: '2px solid #ddd',
          borderRadius: '4px',
          backgroundColor: grey ? '#dddddd4A' : priorities[prioridade].color
        }}
      >
        {prioridade}
      </div>
    )
  }

  const mainCols = [
    { name: 'ID', selector: row => row.id_entrada_fiscal },
    { name: 'P', selector: row => priorityCol(row.prioridade) },
    { name: 'Farol', selector: row => priorityCol(row.farol, true) },
    { name: 'Data de Recebimento', selector: row => toBrDateWithTime(row.data_registro), width: '200px' },
    { name: 'Status de Cadeia', selector: row => row.status_cadeia, wrap: true, width: '300px' },
    { name: 'Resultado CQ', selector: row => row.status_final },
    { name: 'Ordem Produção/Pedido', selector: row => row.ordem_producao },

    { name: 'NF Entrada', selector: row => row.nf_entrada },
    { name: 'Serie NF', selector: row => row.serie_nf },
    { name: 'Origem', selector: row => row.origem },
    { name: 'Canal', selector: row => row.canal },
    { name: 'Produto', selector: row => row.produto },
    { name: 'Desc. Produto', selector: row => row.descricao_produto, width: '300px' },
    { name: 'Cor', selector: row => row.cor_produto },
    { name: 'Desc. Cor', selector: row => row.descricao_cor },
    { name: 'Qtde.', selector: row => row.qtde_entrada },
    { name: 'Verba', selector: row => (row.qtde_entrada * row.preco) || '0.00' },
    { name: 'Preço', selector: row => row.preco },
    { name: 'Coleção', selector: row => row.colecao_ajustada },
    { name: 'Linha', selector: row => row.linha }
  ];

  const checklistColumns = [
    {
      cell: (row) => {
        return (
          <>
            <Button
              style={{ fontWeight: '500' }}
              variant={'primary'}
              onClick={() => getFupData(row)}
            >
              Detalhes
            </Button>
          </>
        )
      }
    },
    ...mainCols
  ];

  const checklistColumnsPrio = [
    {
      cell: (row, index) => {
        return (
          <PrioritySelector
            index={index}
            arrPrioridade={arrPrioridade}
            setArrPrioridade={setArrPrioridade}
          />
        )
      }, width: '150px'
    },
    {
      name: 'Tipo', selector: (_, index) => {
        return (
          <div
            className={styles.sq_flipper}
            style={{
              backgroundColor: arrPrioridade[index]?.nova_nf_segunda_qualidade ? '#FFC107' : '#198754',
              color: arrPrioridade[index]?.nova_nf_segunda_qualidade ? '#000' : '#fff',
              border: arrPrioridade[index]?.nova_nf_segunda_qualidade === arrPrioridade[index]?.nf_segunda_qualidade ? '2px solid #ddd' : '2px solid red',
              height: '32px',
              userSelect: 'none', fontWeight: '500'
            }}
            onClick={() => {
              arrPrioridade[index].nova_nf_segunda_qualidade = !arrPrioridade[index].nova_nf_segunda_qualidade;
              setArrPrioridade([...arrPrioridade]);
            }}
          >
            {arrPrioridade[index]?.nova_nf_segunda_qualidade ? '2Q' : '1Q'}
            {arrPrioridade[index]?.nf_segunda_qualidade !== arrPrioridade[index]?.nova_nf_segunda_qualidade && <span style={{ color: 'red' }} className={styles.sq_flipper_ast}>*</span>}
          </div>
        )
      }
    },
    ...mainCols
  ];

  return (
    <section style={{ margin: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
      <section className={styles.flex_title} style={{ justifyContent: 'space-between' }}>
        <h4 className={styles.title}>Follow Up - Checklist PA</h4>
        <div className={styles.flex_title} style={{ gap: '10px' }}>
          {
            usuarioAdminFup &&
            <Button
              variant={modoPriorizacao ? 'warning' : 'primary'}
              style={{ fontWeight: '500' }}
              onClick={() => setModoPriorizacao(!modoPriorizacao)}
            >
              {modoPriorizacao ? 'Modo Padrão' : 'Modo Priorização'}
            </Button>
          }

          <Button
            variant={'light'}
            style={{ fontWeight: '500', border: '1px solid #ddd' }}
            onClick={() => exportToXlsx(mainGridData, mainCols, `chk_fup_${Math.random().toString(36).slice(2, 8).toUpperCase()}.xlsx`)}
          >
            Exportar
          </Button>

          <Button
            variant={'light'}
            style={{ fontWeight: '500', border: '1px solid #ddd' }}
            onClick={() => setShowResumo(true)}
          >
            Resumo
          </Button>

          {
            (usuarioAdminFup || isAdmin) &&
            <Button
              variant={'light'}
              style={{ fontWeight: '500', border: '1px solid #ddd' }}
              onClick={() => setShowDispensa(true)}
            >
              Dispensa
            </Button>
          }

          {
            (usuarioAdminFup || isAdmin) &&
            <>
              <div className={styles.vertical_separator_full} />

              <Button
                variant={'danger'}
                style={{ fontWeight: '500' }}
                onClick={async () => {
                  try {
                    setShowLoading(true);
                    const res = await api.post('pa/checklist-fup/cancelar-em-analise-revisao');
                    toast.success(`Sucesso, ${res.data[0]} análise(s) atualizada(s).`);
                  } catch (e) {
                    toast.error('Erro ao remover os status em análise.');
                  } finally {
                    setShowLoading(false);
                  }
                }}
              >
                Cancelar Revisões em Andamento
              </Button>

              <Button
                variant={'danger'}
                style={{ fontWeight: '500' }}
                onClick={async () => {
                  try {
                    setShowLoading(true);
                    const res = await api.post('pa/checklist-fup/cancelar-em-analise-checklist');
                    toast.success(`Sucesso, ${res.data[0]} análise(s) atualizada(s).`);
                  } catch (e) {
                    toast.error('Erro ao remover os status em análise.');
                  } finally {
                    setShowLoading(false);
                  }
                }}
              >
                Cancelar Checklist em Andamento
              </Button>
            </>
          }
        </div>
      </section>
      <section style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <FiltroChecklistFup />

        {modoPriorizacao &&
          <>
            <div className={styles.separator} />

            <Form className={styles.filter_wrapper_prio}>
              <PrioritySelectorAll arrPrioridade={arrPrioridade} />
              <div
                className={styles.sq_flipper}
                style={{ backgroundColor: '#198754', fontWeight: '500', color: '#FFF', cursor: 'pointer' }}
                onClick={() => { setModalConfirmacaoTipo(true); setTipoSelecionado(false); }}
              >
                1Q
                <span style={{ position: 'absolute', top: '-10px', right: '0', fontSize: '26px' }}>*</span>
              </div>
              <div
                className={styles.sq_flipper}
                style={{ backgroundColor: '#FFC107', fontWeight: '500', cursor: 'pointer' }}
                onClick={() => { setModalConfirmacaoTipo(true); setTipoSelecionado(true); }}
              >
                2Q
                <span style={{ position: 'absolute', top: '-10px', right: '0', fontSize: '26px' }}>*</span>
              </div>

              <Button
                variant={'secondary'}
                onClick={() => setReseter(!reseter)}
                style={{ margin: '0px auto', fontWeight: '500' }}
                className={styles.filter_btn}
                disabled={semAlteracoes}
              >
                Reset
              </Button>

              <Button
                variant={'success'}
                onClick={() => processarChecklistPriorizacao(arrPrioridade)}
                style={{ margin: '0px auto', fontWeight: '500' }}
                className={styles.filter_btn}
                disabled={semAlteracoes}
              >
                Salvar Alterações
              </Button>
            </Form>
          </>
        }
      </section>
      <section>
        <Tabela
          columns={modoPriorizacao ? checklistColumnsPrio : checklistColumns}
          data={modoPriorizacao ? mainGridDataPrio : mainGridData}
          paginationPerPage={20}
          highlightOnHover={true}
        />

        {modalFup && <PAChecklistFollowUpModal />}
        {showModalHistoricoReanalise && <ReanaliseHistoricoModal />}
        {showResumo && <ResumoFup />}
        {showDispensa && <ModalDispensaFup />}
      </section>

      {
        modalConfirmacaoTipo &&
        <Modal
          size={'md'}
          onHide={() => { setModalConfirmacaoTipo(false); setTipoSelecionado(null); }}
          show={modalConfirmacaoTipo}
          centered
        >
          <Modal.Header style={{ fontWeight: '500' }} closeButton>Priorização</Modal.Header>
          <Modal.Body style={{ fontWeight: '500' }}>
            Deseja alterar o tipo das produções listadas para&nbsp;
            <span style={{
              backgroundColor: tipoSelecionado ? '#FFC107' : '#198754',
              color: tipoSelecionado ? '#000' : '#fff'
            }}>
              {tipoSelecionado ? 'Segunda Quaidade' : 'Primeira Qualidade'}
            </span>?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant={'success'}
              onClick={async () => {
                try {
                  await processarChecklistPriorizacao(arrPrioridade, null, tipoSelecionado);
                } catch (e) {
                  // toast.error('Ocorreu um erro durante a priorização, por favor tente novamente ou entre em contato com o suporte!');
                } finally {
                  setModalConfirmacaoTipo(false); setTipoSelecionado(null);
                }
              }}
              style={{ margin: '0px auto' }}
              className={styles.footer_btn_processamento}
            >
              Processsar Priorização
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </section>
  );
}

export default PAChecklistFollowUp;
